import { authClient, API } from '../index'

// Get all technologies
export const getAllActiveProjectTitles = () => {
    return authClient().get(`${API}/projectTitles/`)
}

// Get projectTitles by id
export const getProjectTitleById = (id) => {
    return authClient().get(`${API}/projectTitles/${id}`)
}

// Create projectTitles
export const postProjectTitle = async (projectTitles) => {
    return authClient().post(`${API}/projectTitles/`, projectTitles)
}

// Update text
export const updateProjectTitle = (id, projectTitles) => {
    return authClient().put(`${API}/projectTitles/${id}`, projectTitles)
}


// Delete projectTitles
export const deleteProjectTitle = (id) => {
    return authClient().delete(`${API}/projectTitles/${id}`)
}
